module.exports = __webpack_public_path__ + "fe040d2cb04b55a3022327d5fd95b417.pdf";